import { selectLoggedInStatus } from '@redux/membership/selectors';
import { connect } from 'react-redux';
import {
	fetchPaiverVendors,
	fetchPvRecAnonVendors,
	fetchSimilarVendorsBasedOnActivity,
} from './actions';
import PVRecWidgetContainer from './components/pvrec_widget.jsx';
import algorithms from './constants/algorithms';

/** @knipignore */
export function mapStateToProps(state) {
	const recommendedVendors = [];
	const { widget } = state;
	const { similarVendorsBasedOnActivityReducer } = widget;
	const vendorToFindSimilar =
		similarVendorsBasedOnActivityReducer.vendorToFindSimilar || null;

	recommendedVendors[algorithms.PAIVER] =
		widget.paiverVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.PAIVER_ROS] =
		widget.paiverVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.SIMILAR_ROS] =
		similarVendorsBasedOnActivityReducer.recommendedVendors;
	recommendedVendors[algorithms.SIMILAR_VENDORS_BASED_ON_ACTIVITY] =
		similarVendorsBasedOnActivityReducer.recommendedVendors;

	return {
		category: state.category,
		isLoggedIn: selectLoggedInStatus(state),
		recommendedVendors,
		vendorToFindSimilar,
	};
}

/** @knipignore */
export const mapDispatchToProps = {
	fetchPaiverVendors,
	fetchPvRecAnonVendors,
	fetchSimilarVendorsBasedOnActivity,
};

export function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		fetchPvRecAnonVendors: dispatchProps.fetchPaiverVendors,
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps,
)(PVRecWidgetContainer);
